module.exports = __webpack_public_path__ + "static/media/design.23e831ec.png";